var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.live)?_c('div',{staticClass:"home-live-slide py-4 py-md-0"},[_c('router-link',{staticClass:"text-light",attrs:{"to":{
      name: 'live',
      params: { ..._vm.live }
    }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.live.picture}}),_c('h6',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.live.name))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }